import { BorderRadius, Color, Spacing, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'

import { getHeaderCellStyles } from '../../utils/getHeaderCellStyles'
import { getStickyCellStyles } from '../../utils/getStickyCellStyles'

export const TableHeader = styled.thead`
  border-radius: ${BorderRadius.R12};
  position: sticky;
  top: 0;
  z-index: ${zIndex.TableHeader};
  background-color: ${Color.White};

  /* a hack for sticky corners https://stackoverflow.com/a/77800868 */
  box-shadow: 0 -7px 0 1px #f5f6f9;

  tr,
  th {
    box-shadow: 0 1px 0 0 ${Color.Grey200};
  }
`

export const HeaderCell = styled.th`
  ${getHeaderCellStyles()};
  ${getStickyCellStyles()};
`

export const CellContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  height: 100%;
`
